import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { NotificationItem, NotificationWithPagination } from "../../types/notificationType";
import { editNotificationVisibilityThunk, fetchNotificationListThunk, fetchUnreadNotificationAmountThunk } from "../thunk/notificationThunk";

export interface Notification {
    unreadNotificationAmount: number;
    allNotificationList: NotificationWithPagination;
    unreadNotificationList: NotificationWithPagination
    notificationToEdit: Partial<NotificationItem>
}

const initialState: Notification = {
    unreadNotificationAmount: 0,
    allNotificationList: {
        totalCount: 0,
        items: []
    },
    unreadNotificationList: {
        totalCount: 0,
        items: []
    },
    notificationToEdit: {}
};

export const notificationReducer = createSlice({
    name: "notifications",
    initialState,
    reducers: {
        setUnreadNotificationAmount: (state, action: PayloadAction<number>) => {
            state.unreadNotificationAmount = action.payload;
        },
        setAllNotificationList: (state, action: PayloadAction<NotificationWithPagination>) => {
            state.allNotificationList = action.payload;
        },
        setUnreadNotificationList: (state, action: PayloadAction<NotificationWithPagination>) => {
            state.unreadNotificationList = action.payload;
        },
        setNotificationToEdit: (state, action: PayloadAction<Partial<NotificationItem>>) => {
            state.notificationToEdit = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(
            fetchUnreadNotificationAmountThunk.fulfilled,
            (state, action) => {
                state.unreadNotificationAmount = action.payload as number;
            }
        );
        builder.addCase(fetchNotificationListThunk.fulfilled, (state, action) => {
            const status = action.meta.arg.status;
            const payload = action.payload as NotificationWithPagination;
            if (status === "Unread") {
                state.unreadNotificationList = payload;
            } else {
                state.allNotificationList = payload;
            }
        });
        builder.addCase(editNotificationVisibilityThunk.fulfilled, (state, action) => {
            const { id, status } = action.payload as { id: number, status: string };
            state.allNotificationList.items = state.allNotificationList.items.map((note) =>
                note.id === id ? { ...note, status } : note
            );
            if (status === "Read") {
                state.unreadNotificationList.items = state.unreadNotificationList.items.filter(note => note.id !== id);
                state.unreadNotificationList.totalCount -= 1;
            }
        });
    }
})

export const {
    setUnreadNotificationAmount,
    setAllNotificationList,
    setUnreadNotificationList,
    setNotificationToEdit
} = notificationReducer.actions;

export default notificationReducer.reducer;